export default __webpack_public_path__ + "static/media/PulseLoanding.490c7c79.svg";